import * as Sentry from '@sentry/solidstart';
import { solidRouterBrowserTracingIntegration } from '@sentry/solidstart/solidrouter';
import { mount, StartClient } from '@solidjs/start/client';
import { bindAuthChange } from '~/utils/authChange';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://43360ebf43d228558698966df1f41a4d@sentry.magicdoor.io/3',
    integrations: [solidRouterBrowserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

mount(() => <StartClient />, document.getElementById('app') as HTMLDivElement);

bindAuthChange(() => {
  window.location.reload();
});
